import * as api from 'helpers/api';
import snakecaseKeys from 'snakecase-keys';

const rootPath = '/connections';

export function connect(databaseEntityType, databaseEntityId, type, id) {
  return (
    api.post(`${rootPath}/connect`, { entityType: databaseEntityType, entityId: databaseEntityId, type, id })
      .then(data => data.object)
  );
}

export function bulkCopyAndConnect(database, models) {
  return api.post(`${rootPath}/bulk_copy`, { database, models });
}

export function copyAndConnect(database, type, id) {
  return api.post(`${rootPath}/copy`, { database, type, id });
}

export function unlink(linkId, type, id) {
  return (
    api.deleteRequest(`${rootPath}/unlink`, { data: snakecaseKeys({ linkId, type, id }) }).then(data => data.object)
  );
}
